module.exports = {"id":"211348","name":"Stole Dimitrievski","rating":"71","photo":"./data/images/photos/1/211348.png","club":{"name":"Gimnàstic","logo":"./data/images/clubs/Gimnastic.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StoleDimitrievski0.json
// module id = 4049
// module chunks = 0